import { DatePipe } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserAccountFacade } from "@spartacus/user/account/root";
import html2pdf from 'html2pdf.js';
import { Subscription } from "rxjs";
import { CommonUtils } from "src/app/shared/utils/common.utils";
import { CustomCustomerServiceBrService } from "../custom-customer-service-br.service";
import { TicketDetailsComponent } from "../ticket-details/ticket-details.component";

@Component({
    selector: 'app-ticket-history-page',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './ticket-history-page.component.html',
    styleUrls: ['./ticket-history-page.component.scss'],
    standalone: false
})
export class TicketHistoryPageComponent implements OnInit, OnDestroy {
  ticketToDisplaySubscriber: Subscription;
  ticketDetails: any;
  userId: any;
  pageList = ['18 por página', '36 por página', '72 por página'];
  pageSizeperPage = '18 por página';
  pageSize = 18;
  @ViewChild('facetsRwd', { static: false }) private readonly facetsRwd;
  facetsList = [];
  ticketTypeList: any;
  selectedType = 'All';
  ticketStatusList: any;
  selectedStatus = 'All';
  ticketId: any;
  constructor(
    private readonly customerService: CustomCustomerServiceBrService,
    private readonly cdr: ChangeDetectorRef,
    private readonly modalService: NgbModal,
    private readonly user: UserAccountFacade,
    public datepipe: DatePipe,
  ) { }

  ngOnInit(): void {
    this.user.get().subscribe((res: any) => {
      if (res) {
        this.userId = res?.userName;
      }
    });
    this.ticketToDisplaySubscriber =
      this.customerService.ticketsToDisplay?.subscribe((res: any) => {
        if (res) {
          this.ticketDetails = res;
          this.cdr.detectChanges();
        }
      });
    this.customerService.getTicketCategories();
    this.customerService.ticketCategories.subscribe((res: any) => {
      if (res) {
        this.ticketTypeList = res?.ticketCategories;
        this.ticketTypeList.unshift({ id: 'All', name: 'All' });
        this.cdr.detectChanges();
      }
    });
    this.customerService.getTicketStatus();
    this.customerService.ticketStatus.subscribe((res: any) => {
      if (res) {
        this.ticketStatusList = res;
        this.ticketStatusList.unshift({ code: 'All', name: 'All' }, { code: 'All_Open', name: 'Tickets Abertos' });
        this.cdr.detectChanges();
      }
    });
  }
  generateXls() {
    const ticketHistory = [];
    if (this.ticketDetails?.tickets?.length === 0) {
      ticketHistory.push({
        'Nº Ticket': '',
        'Tipo': '',
        'Subtipo': '',
        'Submissão': '',
        'Ultima atualização': '',
        'Status': '',
        'Cliente': ''
      });
    }
    this.ticketDetails?.tickets.forEach((element) => {
      ticketHistory.push({
        'Nº Ticket': element?.id,
        'Tipo': element?.ticketCategory?.name,
        'Subtipo': element?.ticketSubType,
        'Submissão': this.datepipe.transform(element?.createdAt?.slice(0, 10), 'dd/MM/yyyy'),
        'Ultima atualização': this.datepipe.transform(element?.modifiedAt?.slice(0, 10), 'dd/MM/yyyy'),
        'Status': element?.status?.name,
        'Cliente': element?.b2bUnitName
      });
    });
    this.customerService.downloadXls(ticketHistory, 'Ticket History');
  }
  generateSavePdf() {
    const options = {
      margin: [10, 10, 19, 10] as [number, number, number, number],
      filename: 'Ticket History.pdf',
      image: { type: 'jpeg' as const },
      html2canvas: {},
      jsPDF: { orientation: 'portrait' },
    } as any;
    const element: HTMLElement | null = document.getElementById('ordersTable');
    if (element) {
      html2pdf().from(element).set(options).save();
    }
  }
  changePageSize() {
    const params = `currentPage=0&pageSize=${parseInt(this.pageSizeperPage?.slice(0, 2))}&sort=byTicketId`;
    this.customerService.getTicketsToDisplay(this.userId, params);
  }
  paginationNext() {
    const params = `currentPage=${this.ticketDetails?.pagination?.currentPage + 1}&pageSize=${this.ticketDetails?.pagination?.pageSize}&sort=byTicketId`;
    this.customerService.getTicketsToDisplay(this.userId, params);
  }
  paginationPrev() {
    const params = `currentPage=${this.ticketDetails?.pagination?.currentPage - 1}&pageSize=${this.ticketDetails?.pagination?.pageSize}&sort=byTicketId`;
    this.customerService.getTicketsToDisplay(this.userId, params);
  }
  viewTicket(ticketId): void {
    this.customerService.getTicketDetails(ticketId, this.userId);
    this.modalService.open(TicketDetailsComponent, {
      windowClass: 'ticketdetails-viewmodal',
    });
  }
  sortColumn(event, fieldName, dataList, type): any {
    CommonUtils.onSortClick(event, fieldName, dataList, type); // Column Sorting
  }
  refine(): void {
    this.modalService.open(this.facetsRwd);
  }

  hide(): void {
    this.modalService.dismissAll(this.facetsRwd);
  }
  removeFacet(filter) {
    let params = `currentPage=0&pageSize=${parseInt(this.pageSizeperPage?.slice(0, 2))}&sort=byTicketId`;
    if (filter?.id === 'Type') {
      this.selectedType = 'All';
      if (this.selectedStatus !== 'All') {
        params = `${params}&status=${this.selectedStatus}`;
      }
      if (this.ticketId !== null && this.ticketId !== '' && this.ticketId !== undefined) {
        params = `${params}&ticketNumber=${this.ticketId}`;
      }
    } else if (filter?.id === 'Status') {
      this.selectedStatus = 'All';
      if (this.selectedType !== 'All') {
        params = `${params}&ticketCategory=${this.selectedType}`;
      }
      if (this.ticketId !== null && this.ticketId !== '' && this.ticketId !== undefined) {
        params = `${params}&ticketNumber=${this.ticketId}`;
      }
    } else if (filter?.id === 'ID') {
      this.ticketId = '';
      if (this.selectedType !== 'All') {
        params = `${params}&ticketCategory=${this.selectedType}`;
      }
      if (this.selectedType !== 'All') {
        params = `${params}&ticketCategory=${this.selectedType}`;
      }
    }
    this.customerService.getTicketsToDisplay(this.userId, params);
    this.facetsList.forEach((element, index) => {
      if (element === filter) {
        this.facetsList.splice(index, 1);
        this.cdr.detectChanges();
      }
    });
  }
  clearFilters() {
    this.selectedStatus = 'All';
    this.selectedType = 'All';
    this.ticketId = '';
    this.facetsList = [];
    const params = `currentPage=0&pageSize=${parseInt(this.pageSizeperPage?.slice(0, 2))}&sort=byTicketId`;
    this.customerService.getTicketsToDisplay(this.userId, params);
  }
  applyFilter() {
    this.facetsList = [];
    let params = `currentPage=0&pageSize=${parseInt(this.pageSizeperPage?.slice(0, 2))}&sort=byTicketId`;
    if (this.selectedType !== 'All') {
      params = `${params}&ticketCategory=${this.selectedType}`;
      this.facetsList.push({ id: 'Type', value: this.ticketTypeList?.find(item => item?.id === this.selectedType)?.name });
    }
    if (this.selectedStatus !== 'All') {
      params = `${params}&status=${this.selectedStatus}`;
      this.facetsList.push({ id: 'Status', value: this.ticketStatusList?.find(item => item?.code === this.selectedStatus)?.name });
    }
    if (this.ticketId !== null && this.ticketId !== '' && this.ticketId !== undefined) {
      params = `${params}&ticketNumber=${this.ticketId}`;
      this.facetsList.push({ id: 'ID', value: this.ticketId });
    }
    this.customerService.getTicketsToDisplay(this.userId, params);
  }
  ngOnDestroy() {
    this.ticketToDisplaySubscriber?.unsubscribe();
  }
}
